import React, {useContext} from "react";
import './ClientInvoice.css'
import DigitalInvoiceHeader from "./DigitalInvoiceHeader";
import ContactPersonRecord from "./ContactPersonRecord";
import OriginDestinationRecord from "./OrigindestinationRecord";
import ImportantNoticeRecord from "./ImportantNoticeRecord";
import Signatures1Info from "./Signatures1Info";
import MovingChargesRecord from "./MovingChargesRecord";
import NotesAndChargesTableRecord from "./NotesAndChargesTableRecord";
import Acknowledgement from "./Acknowledgement";
import Signatures2Info from "./Signatures2Info";
import DefaultModal from "../CommonComponents/DefaultModal";
import {RecordsManagementContext,ViewMangementContext} from "../StatesMangement/InitialiseContext";
import DefaultAlerts from "../CommonComponents/DefaultAlerts";
import CompanyBranchAndEstimateInfo from "../ClientInvoice2/CompanyBranchAndEstimateInfo";


export default () => {
    let RecordsManagement = useContext(RecordsManagementContext)
    let InvoiceRecord =RecordsManagement.IV1_PageDetails
    let PageView = useContext(ViewMangementContext)
    let Record = useContext(RecordsManagementContext).IV1_PageDetails.BackgroundColor
    let backgroundColor1 = Record.BgColor1
    let backgroundColor2 = Record.BgColor2
    return (
        <div style={{backgroundColor: "#172b4d", backgroundImage:  `linear-gradient(45deg, ${backgroundColor1} 15%, ${backgroundColor2} 85%)`}}>
            <div className="width-wrapper">
                <DefaultAlerts/>
                <DefaultModal/>
                <DigitalInvoiceHeader/>
                <table className="table">
                    <tbody>
                    <tr>
                        <td className="td-main-bost" colSpan="2" style={{paddingTop: "50px"}}>
                            <CompanyBranchAndEstimateInfo/>
                        </td>
                    </tr>
                    <tr>
                        <td className="td-main-bost set-pid-2" style={{paddingTop:"3% !important"}}>
                            <div className="ml-2" style={{fontWeight:'bold'}}>{InvoiceRecord.ClientName}</div>
                            <ContactPersonRecord/>
                        </td>
                    </tr>
                    <tr>
                        <td className="td-main-bost">
                            <OriginDestinationRecord/>
                        </td>
                    </tr>
                    <tr>
                        <td className="td-main-bost">
                            <ImportantNoticeRecord/>
                        </td>
                    </tr>
                    <tr>
                        <td className="td-main-bost">
                            <Signatures1Info/>
                        </td>
                    </tr>
                    <tr>
                        <td className="td-main-bost">
                            <MovingChargesRecord/>
                        </td>
                    </tr>
                    <tr>
                        <td className="td-main-bost">
                            <NotesAndChargesTableRecord/>
                        </td>
                    </tr>
                    <tr>
                        <td className="td-main-bost">
                            <Acknowledgement/>
                        </td>
                    </tr>
                    <tr>
                        <td className="td-main-bost">
                            <Signatures2Info/>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    )
}


